<template>
  <div class="fashion-detail">
    <a-list :data-source="dataSource">
      <a-list-item slot="renderItem" slot-scope="item, idx">
        <div class="fd-item">
          <div class="item-th" @click="changeSorter(item)">
            <div class="item-title">
              <span>{{item.ch}}</span>
              <span class="item-rank" v-if="item.rank">排名</span>
            </div>
            <span class="sorter" v-if="item.sorter">
              <a-icon type="caret-up" :class="`i-sorter ${item.sorter_key === filterParam.orderBy && filterParam.orderType === 'asc'  ? 'active' : ''}`" />
              <a-icon type="caret-down" :class="`i-sorter ${item.sorter_key === filterParam.orderBy && filterParam.orderType === 'desc' ? 'active' : ''}`" />
            </span>
          </div>
          <div class="item-content">
            <div class="item-td">{{item.c1}}
              <span v-if="item.rank" class="item-rank">{{item.c1_rank}}</span>
            </div>
            <div class="item-td">{{item.c2}}
              <span v-if="item.rank" class="item-rank">{{item.c2_rank}}</span>
            </div>
            <div class="item-td">{{item.c3}}
              <span v-if="item.rank" class="item-rank">{{item.c3_rank}}</span>
            </div>
            <div class="item-td">{{item.c4}}
              <span v-if="item.rank" class="item-rank">{{item.c4_rank}}</span>
            </div>
            <div class="item-td">{{item.c5}}
              <span v-if="item.rank" class="item-rank">{{item.c5_rank}}</span>
            </div>
          </div>
        </div>
      </a-list-item>
    </a-list>
    <div class="page-wrap">
      <a-pagination v-model="filterParam.currentPage" :pageSize="5" :total="fashionList.length" :show-total="total => `共 ${total} 条`" show-less-items />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import _ from 'lodash';
import { FASHION_STATE_MAP, WY_TYPE_MAP } from '@/constants/fixed';
import { format } from '@/utils/utils';

export default {
  name: 'FashionDetail',
  props: ['fashionList', 'dateType'],
  data() {
    return {
      filterParam: {
        orderBy: 'last_total_sales',
        orderType: 'desc',
        currentPage: 1
      },
    }
  },
  watch: {
    filterData() {
      this.$emit('updateFilterFashionList', this.filterData);
    }
  },
  computed: {
    fields() {
      const isL36 = this.$service.PROJ_CODE === 'l36';
      return [
        { title: '状态', dataIndex: 'state' },
        ...(isL36 ? [{ title: '纹玉类型', dataIndex: 'last_money_type' }] : []),
        { title: '总销量', sorter: true, dataIndex: 'last_total_sales', rank: true },
        ...(isL36 ? [{ title: '销售额', sorter: true, dataIndex: 'last_total_yuanbao', rank: true }] : []),
        { title: `本${this.dateType === 0 ? '周' : '月'}穿戴`, sorter: true, dataIndex: 'last_users', rank: true },
        { title: '首月销量', sorter: true, dataIndex: 'last_first_month_sales' },
        { title: '首售日期', sorter: true, dataIndex: 'create_dt' },
      ]
    },
    filterData() {
      const sortedData = this.fashionList.sort((prev, next) => {
        let prevVal = prev[this.filterParam.orderBy];
        let nextVal = next[this.filterParam.orderBy];
        if (this.filterParam.orderBy === 'create_dt') {
          prevVal = moment(prev.create_dt).unix();
          nextVal = moment(next.create_dt).unix();
        }
        return this.filterParam.orderType === 'desc' ? (nextVal - prevVal) : (prevVal - nextVal);
      });

      return sortedData.filter((s, idx) => {
        return idx < 5 * this.filterParam.currentPage && idx >= (5 * (this.filterParam.currentPage - 1))
      });
    },
    ranks() {
      const totalSalesRank = (this.fashionList || []).sort((prev, next) => next.last_total_sales - prev.last_total_sales).map(v => v.fashion_id);
      const usersRank = (this.fashionList || []).sort((prev, next) => next.last_users - prev.last_users).map(v => v.fashion_id);
      const yuanbaoRank = (this.fashionList || []).sort((prev, next) => next.last_total_yuanbao - prev.last_total_yuanbao).map(v => v.fashion_id);

      return {
        last_total_sales_rank: totalSalesRank,
        last_users_rank: usersRank,
        last_total_yuanbao_rank: yuanbaoRank
      };
    },
    dataSource() {
      const res = [];
      this.fields.forEach((field, idx) => {
        const tmp = { ch: field.title, sorter: field.sorter, sorter_key: field.dataIndex, rank: field.rank };
        this.filterData.forEach((fdata, jdx) => {
          const val = fdata[field.dataIndex];
          switch(field.dataIndex) {
            case 'state':
              tmp[`c${jdx + 1}`] = FASHION_STATE_MAP[val]?.label || '--';
              break;
            case 'last_money_type':
              tmp[`c${jdx + 1}`] = WY_TYPE_MAP[val]?.label || '--';
              break;
            case 'last_total_sales':
            case 'last_users':
            case 'last_first_month_sales':
            case 'last_total_yuanbao':
              tmp[`c${jdx + 1}`] = _.isNumber(val) ? format(val) : '--';
              if (field.rank && this.ranks[`${field.dataIndex}_rank`]) {
                tmp[`c${jdx + 1}_rank`] = this.ranks[`${field.dataIndex}_rank`].findIndex(v => v === fdata.fashion_id) + 1;
              }
              break;
            case 'create_dt':
            default:
              tmp[`c${jdx + 1}`] = val;
              break;
          }
        });
        res.push(tmp);
      });
      return res;
    }
  },
  methods: {
    changeSorter(tar) {
      if (tar.sorter) {
        if (this.filterParam.orderBy === tar.sorter_key) {
          this.filterParam.orderType = (this.filterParam.orderType === "desc") ? "asc" : "desc";
        } else {
          this.filterParam.orderBy = tar.sorter_key;
          this.filterParam.orderType = "desc";
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.fashion-detail {
  width: 100%;
  .fd-item {
    display: flex;
    width: 100%;
    .item-rank {
      font-size: 12px;
      color: #C07F00;
      border-top: 1px dashed #B7B7B7;
      min-width: 30px;
    }
    .item-th {
      width: 80px;
      padding-right: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      .item-title {
        display: flex;
        flex-direction: column;
      }
      .sorter {
        display: flex;
        flex-direction: column;
      }
    }
    .item-content {
      display: flex;
      align-items: center;
      flex: 1;
    }
    .item-td {
      width: 20%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .i-sorter {
      font-size: 12px;
      cursor: pointer;
      &.active {
        color: #267fff;
      }
    }
  }
  .page-wrap {
    text-align: right;
  }

  .ant-list-bordered {
    .ant-list-item {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>